import Vue from 'vue';

export default {
	'TASK_LIST': async (context, params) => {
		return await Vue.http.get(`${process.env.VUE_APP_API_URL}/tasks`, {params: params})
			.then(
				(res) => {
					context.commit('TASK_LIST', res.body);
					return res;
				},
				(err) => {
					console.log(err);
					return err;
				}
			)
			.catch(err => console.error(`catch, ${err}`));
	},

	'TASK': async (context, params) => {
		return await Vue.http.get(`${process.env.VUE_APP_API_URL}/tasks/${params}`)
			.then(
				(res) => {
					return res;
				},
				(err) => {
					console.log(err);
					return err;
				}
			)
			.catch(err => console.error(`catch, ${err}`));
	},

	'TASK_ANSWER': async (context, params) => {
		return await Vue.http.post(`${process.env.VUE_APP_API_URL}/tasks/answer`, params)
			.then(
				(res) => {
					return res;
				},
				(err) => {
					console.log(err);
					return err;
				}
			)
			.catch(err => console.error(`catch, ${err}`));
	},
};
